import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EAgent = {
  title: {
    name: ['پیام', 'پیام ها'],
  },
  routes: PATH_DASHBOARD.notification,
  api: api.notification,
};

export default EAgent;
